import { render, staticRenderFns } from "./LanguageSwitcherList.vue?vue&type=template&id=690e4045&scoped=true&"
import script from "./LanguageSwitcherList.vue?vue&type=script&lang=js&"
export * from "./LanguageSwitcherList.vue?vue&type=script&lang=js&"
import style0 from "./LanguageSwitcherList.vue?vue&type=style&index=0&id=690e4045&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690e4045",
  null
  
)

component.options.__file = "LanguageSwitcherList.vue"
export default component.exports